import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {showModalAction} from '@/state/slices/modalSlice';
import {dispatch} from '@/state/store';

const usePopupCoordinator = (isPendingSelector, popupsSelector, resetPopupAction) => {
    const isPending = useSelector(isPendingSelector);
    const popups = useSelector(popupsSelector);

    useEffect(() => {
        if (isPending) {
            return;
        }

        const popupsToShow = {};

        Object.entries(popups).forEach(([popupKey, popupData]) => {
            if (popupData.state.isVisible) {
                popupsToShow[popupKey] = popupData;
            }
        });

        Object.entries(popupsToShow).forEach(([popupKey, popupData]) => {
            dispatch(resetPopupAction(popupKey));

            if (popupData.ignoreIf && popupData.ignoreIf.some((key) => popupsToShow[key])) {
                return;
            }

            dispatch(
                showModalAction({
                    modalType: popupKey,
                    modalProps: popupData.state.props,
                })
            );
        });
    }, [isPending, popups, resetPopupAction]);
};

export default usePopupCoordinator;
